module.exports = __webpack_public_path__ + "h5/img/languan_1.ff00c5ea.png";